import React from 'react';
import { Typography } from '@material-ui/core';
import CustomDropdown, {
  ICustomDropdown,
} from '../../selectors/CustomDropdown';

import { useStyles } from './styles';

interface IInfoCard extends ICustomDropdown {
  title: string;
}

const InfoCardWithDropdown: React.FC<IInfoCard> = ({ title, ...rest }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Typography className={classes.title} variant="h3" gutterBottom>
        {title}
      </Typography>
      <CustomDropdown {...rest} />
    </div>
  );
};

export default InfoCardWithDropdown;
